/* eslint-disable no-dupe-keys */
import { proxyBE } from "./common";

export const esse3Service = {
  exportRankingsByCompany(aa, company) {
    return proxyBE.get(`admin/esse3/export-rankings/${company}/${aa}`, {
      responseType: "blob",
    });
  },
};
